import { useEffect, useState } from "react";

import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectCurrencies } from "@evr/store/slices/currencies";
import { Currency } from "@evr/types";

export interface PriceProps {
  price: number;
  transactionCurrency: Currency;
}

const Price = ({ price, transactionCurrency }: PriceProps) => {
  return (
    <>
      {transactionCurrency?.symbol}
      {price.toFixed(transactionCurrency?.isZeroDecimal ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    </>
  );
};

export default Price;
